export enum StatusEnum {
    ACTIVE = "ACTIVE",
    WON = "WON",
    LOST = "LOST",
    PARTIALLY_WON = "PARTIALLY_WON",
    CANCELED = "CANCELED"
}

export const pastStatuses: StatusEnum[] = [StatusEnum.WON, StatusEnum.LOST, StatusEnum.PARTIALLY_WON, StatusEnum.CANCELED];